import { Stack, styled } from "@mui/material";
import { cardName } from "../classes.js";
const Heading = styled(Stack, {
  name: cardName,
  overridesResolver: (_, styles) => [styles.heading],
  slot: "Heading"
})`
  flex: 1 1 auto;
  width: 100%;
`;
export {
  Heading
};
//# sourceMappingURL=Heading.js.map
